// Only use with this app's API; never attach account credentials to third parties.
export const siteRequestHeaders = () => {
  const token = localStorage.getItem('gv_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};